import { Field, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class ManifestNo {
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  number?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  plantId?: string
}
